"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStrapiErrorMessages = exports.createRequestActionType = void 0;
const createRequestActionType = (type, id) => `@ReactReduxRequest/${type}_${id.toUpperCase()}`;
exports.createRequestActionType = createRequestActionType;
const getStrapiErrorMessages = (message) => {
    const messages = [];
    message.forEach((msg) => msg.messages.forEach((msgs) => messages.push(msgs)));
    return messages;
};
exports.getStrapiErrorMessages = getStrapiErrorMessages;
